/**
 * Shared metadata helper functions
 * Consolidates duplicate logic for metadata mapping and filter value extraction
 */

import { COLUMN_FILTER_MAP } from './filterConstants';

/**
 * Get metadata counts for a column from filter metadata
 */
export const getMetaCounts = (accessorKey: string | undefined, metadata: any) => {
  if (!metadata || !accessorKey) return undefined;

  switch (accessorKey) {
    case 'aggregateShipmentType':
      return metadata?.shipmentTypeCounts;
    case 'date':
      return metadata?.dateCounts;
    case 'tradeLane':
      return metadata?.tradeLaneCounts;
    case 'service':
      return metadata?.serviceCounts;
    case 'incoterm':
      return metadata?.incotermCounts;
    case 'billedEntity':
      return metadata?.billedEntityCounts;
    case 'shipper':
      return metadata?.shipperCounts;
    case 'consignee':
      return metadata?.consigneeCounts;
    case 'invoiceNumber':
      return metadata?.invoiceNumberCounts;
    case 'shipmentNumber':
      return metadata?.shipmentNumberCounts;
    case 'status':
      return metadata?.statusCounts;
    default:
      return undefined;
  }
};

/**
 * Get current filter values for a column from context filters
 */
export const getCurrentFilterValues = (accessorKey: string, filters: any): string[] | undefined => {
  if (!filters?.filters) return undefined;

  const nested = filters.filters;
  const mapping = COLUMN_FILTER_MAP[accessorKey];
  if (!mapping) return undefined;

  let result: string[] | undefined;

  if (mapping.filterGroup === 'filters') {
    // Direct filter (status, invoiceNumber)
    result = nested[mapping.apiKey];
  } else {
    // Nested filter group
    const filterGroup = nested[mapping.filterGroup];
    result = filterGroup?.[mapping.apiKey];
  }

  return result && result.length > 0 ? result : undefined;
};
